import * as React from 'react';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import connectToRouter from 'js/lib/connectToRouter';
import { FormattedHTMLMessage, FormattedMessage } from 'js/lib/coursera.react-intl';

import { Box } from '@coursera/coursera-ui';

import _t from 'i18n!nls/user-account';

type PropsToComponent = {
  router: InjectedRouter;
};
/**
 * Complete a registration or account linking with a social account.
 *
 * For now only supports Facebook and Apple.
 */
const LinkedAccountForm = ({ router }: PropsToComponent) => {
  const { serviceCode } = router.location.query;

  const SERVICES = {
    apple: _t('Apple'),
    facebook: _t('Facebook'),
    google: _t('Google'),
  };

  const currentService = serviceCode.charAt(0).toUpperCase() + serviceCode.slice(1);
  const hiddenServices = ['apple', 'facebook', 'google']
    .filter((value) => value !== serviceCode)
    .map((name) => name.charAt(0).toUpperCase() + name.slice(1));

  return (
    <Box rootClassName="rc-LinkedAccountForm" flexDirection="column">
      <h2>
        <FormattedMessage
          message={_t('You already have a Coursera account through {service}')}
          // @ts-expect-error TS7016 TODO: SERVICES[serviceCode] needs to be typed
          service={SERVICES[serviceCode]}
        />
      </h2>
      <p>
        <FormattedHTMLMessage
          message={_t(
            'Please log into Coursera by clicking the <strong>Continue with {service}</strong> button above. To link your account to a different service, you can do so in your account settings.'
          )}
          // @ts-expect-error TS7016 TODO: SERVICES[serviceCode] needs to be typed
          service={SERVICES[serviceCode]}
        />
      </p>
      <style>
        {`
        .${currentService}Alternative button { margin: 0 !important; }
        .AppleAlternative .horizontal-box, .FacebookAlternative .horizontal-box { display: none; }
        `}
        {hiddenServices.map((service) => `.${service}Alternative button { display: none; }`)}
      </style>
    </Box>
  );
};

export default connectToRouter<PropsToComponent, {}>((router) => ({ router }))(LinkedAccountForm);
